import { render } from "./paymentDetail.vue?vue&type=template&id=68c4a333&scoped=true"
import script from "./paymentDetail.vue?vue&type=script&lang=js"
export * from "./paymentDetail.vue?vue&type=script&lang=js"

import "./paymentDetail.vue?vue&type=style&index=0&id=68c4a333&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-68c4a333"

export default script